<template>
  <div class="admin-users px-2 px-md-4 py-2 py-md-4">
    <div class="admin-users--nav">
      <b-nav tabs>
        <b-nav-item to="/admin/users" :active="isUsersTab">Users</b-nav-item>
        <b-nav-item to="/admin/invitations" :active="isInvitationsTab">Invitations</b-nav-item>
      </b-nav>
    </div>
    <div class="admin-users--content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "AdminUsers",
  computed: {
    isUsersTab() {
      return ["Admin Users", "Admin Create User", "Admin Edit User"].includes(this.$route.name);
    },
    isInvitationsTab() {
      return ["Admin User Invitations", "Admin User Invitation Detail"].includes(this.$route.name);
    },
  }
};
</script>

<style lang="scss">
.admin-users {
  width: 100%;
  height: 100%;

  &--nav {
    width: 100%;
    height: 45px;
  }
  &--content {
    width: 100%;
    height: calc(100% - 45px);
  }
}
</style>
